import { render, staticRenderFns } from "./Product_HighCost.vue?vue&type=template&id=16fee598&scoped=true&"
import script from "./Product_HighCost.vue?vue&type=script&lang=js&"
export * from "./Product_HighCost.vue?vue&type=script&lang=js&"
import style0 from "./Product_HighCost.vue?vue&type=style&index=0&id=16fee598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fee598",
  null
  
)

export default component.exports